import React, { useState } from "react"

import { ResultGrid } from "@app/scripts/components/result-grid"
import { ResultFooter } from "@app/scripts/components/result-footer"
import { SearchBanner } from "@app/scripts/components/search-banner"
import { FilterSortDrawer } from "@app/scripts/components/filter-sort-drawer"
import { useSearchspringSearchContext } from "@app/scripts/providers/searchspring"
import { SearchNoResults } from "@app/scripts/components/search-no-results"

export type Props = {
  query: string
}

export function SearchGrid({ query }: Props) {
  const [searchTerm, setSearchTerm] = useState(query)
  const { response, refine } = useSearchspringSearchContext()

  const hasResponse = !!response
  const totalResults = response?.pagination?.totalResults ?? 0

  return (
    <>
      {hasResponse && (
        <SearchBanner
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          refine={refine}
          response={response}
        />
      )}

      <FilterSortDrawer />

      <ResultGrid searchPage={true} />

      {hasResponse && totalResults === 0 && (
        <SearchNoResults searchPage={true} />
      )}

      {hasResponse && totalResults > 0 && <ResultFooter />}
    </>
  )
}
